import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router";

import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Risk from "./pages/Risk";
import Projects from "./pages/Projects";
import National from "./pages/National";
import Corporate from "./pages/Corporate";
import Contact from "./pages/Contact";
import Scroll from "./pages/Scroll";
import NewsBlogs from "./pages/NewsBlogs";
import Insights from "./pages/Insights";


function App() {
  return (
    <Router>
      <Scroll />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/Home" element={<Home />} />
        <Route path="/About" element={<About />} />
        <Route path="/Services" element={<Services />} />
        <Route path="/Risk" element={<Risk />} />
        <Route path="/Projects" element={<Projects />} />
        <Route path="/National" element={<National />} />
        <Route path="/Corporate" element={<Corporate />} />
        <Route path="/Contact" element={<Contact />} />
        <Route path="/News" element={<NewsBlogs />} />
         <Route path="/Insights" element={<Insights />} />
      </Routes>
    </Router>
  );
}

export default App;
